const mbtiData = {
  INTJ: {
    name: 'INTJ',
    dignity: '建筑师型人格',
    account: '理性、富有创造力，善于规划和逻辑分析',
    analyze:
      '内向（I）：INTJ 享受独处时光，在独自思考中能获取能量，社交对他们来说是消耗精力的活动，所以社交场合中往往较为沉默。比如，在团体活动时，他们更愿意在角落观察众人交流，而不是主动参与闲聊。</br>直觉（N）：更倾向于关注抽象概念、未来趋势和可能性，不局限于当下的具体事实，能从宏观角度思考问题。以科技领域为例，他们会提前预见到人工智能未来在医疗、交通等多领域的变革，而不只是着眼于当下的技术应用。</br>思考（T）：做决策时，他们依靠逻辑分析，客观冷静地权衡利弊，以理性思维判断事物。在工作中，面对项目方案的选择，会通过数据对比、风险评估等方式，选出最优解。</br>判断（J）：喜欢有条理、有计划地生活，面对任务会提前规划，追求高效完成目标，注重结果和效率。例如，制定年度学习计划时，会精确到每个月、每周要完成的学习内容。</br>INTJ 善于构建复杂理论，在科研、金融分析等领域，凭借理性规划和深刻洞察，成为行业的引领者。但他们可能因过于理性，在处理人际关系时显得有些冷漠，缺乏情感共鸣',
    results:
      '1. 计算机科学家：开发前沿算法和软件系统。</br>2. 金融分析师：精准分析市场数据，预测走势。</br>3. 战略规划师：为企业制定长远发展规划。</br>4. 系统工程师：设计和优化复杂系统。</br>5. 专利代理人：处理专利申请和知识产权事务。',
  },
  INTP: {
    name: 'INTP',
    dignity: '逻辑学家型人格',
    account: '充满好奇心，喜欢探索理论和抽象概念',
    analyze:
      '内向（I）：专注于内心世界，不依赖外界社交获取快乐，在社交中容易感到疲惫，更愿意独自思考问题。比如在经历过热闹的社交场合后，他们需要独自静处一段时间来恢复精力。</br>直觉（N）：对抽象理论和逻辑关系兴趣浓厚，能洞察事物背后的本质联系，挖掘深层次的原理。像在研究哲学问题时，能深入剖析各种哲学流派的底层逻辑。</br>思考（T）：以逻辑为准则，追求真理，面对问题时会进行深入的逻辑推导，不轻易被情感左右。在学术探讨中，会用严谨的论证反驳错误观点。</br>知觉（P）：生活较为灵活，喜欢探索各种可能性，不被固定计划束缚，思维活跃但可能在执行上有所欠缺。常常有新的创意项目构思，但因缺乏持续推进的动力，难以落地。</br>在学术研究、编程等需要深度思考的领域，INTP 凭借对知识的渴望和独特的思维方式，不断挑战传统理论。然而，他们可能会因过于追求完美的逻辑，陷入过度思考，错过行动时机',
    results:
      '1. 数学家：从事理论研究和复杂计算。</br>2. 物理学家：探索物质变化的基本规律。</br>3. 软件工程师：开发创新软件应用。</br>4. 哲学家：思考人生和世界本质问题。</br>5. 数据分析师：从海量数据中挖掘价值。',
  },
  ENTJ: {
    name: 'ENTJ',
    dignity: '指挥官型人格',
    account: '自信果断，具备强大的领导能力和组织能力',
    analyze:
      '外向（E）：在社交场合中自信满满，具有强大的社交魅力和领导力，能够轻松主导交流和讨论。在讨论上，他们能迅速掌控节奏，引导众人达成共识。</br>直觉（N）：善于把握宏观趋势，从长远角度规划发展，能预见未来的机会和挑战。在企业战略制定中，能提前布局新兴市场，抢占先机。</br>思考（T）：决策基于理性分析，果断且有力，以事实和逻辑为依据做出判断。面对公司危机，能迅速分析形势，制定应对策略。</br>判断（J）：热衷于掌控局面，喜欢制定清晰的计划并积极推动执行，是天生的领导者。在团队项目中，会明确分工，设定严格的时间节点，确保项目顺利推进。</br>ENTJ 在政治、商业等领域发挥着重要作用，如苹果公司的创始人史蒂夫・乔布斯。不过，他们可能过于强势，听不进他人意见，导致团队内部矛盾。',
    results:
      '1. 企业高管：管理公司运营事务，制定战略决策。</br>2. 政治家：参与政治活动，制定重大政策。</br>3. 项目经理：统筹项目进度和资源。</br>4. 投资银行家：处理金融投资业务。</br>5. 军事指挥官：指挥军事行动。',
  },
  ENTP: {
    name: 'ENTP',
    dignity: '辩论家型人格',
    account: '聪明机智，思维敏捷，富有创新精神',
    analyze:
      '外向（E）：热衷于社交讨论，思维敏捷，喜欢与他人交流观点，在社交中充满活力。在社交聚会中，常常是话题的发起者，能带动全场气氛。</br>直觉（N）：富有创意，能快速关联不同的想法，从不同角度看待问题，提出新颖的观点。在广告创意策划中，能想出独特的宣传点子。</br>思考（T）：以逻辑说服他人，享受辩论过程，用严密的逻辑论证自己的观点。在辩论赛中，凭借出色的口才和逻辑思维，赢得比赛。</br>知觉（P）：灵活应变，不被计划束缚，善于在变化中寻找新的机会和解决方案。面对市场变化，能迅速调整营销策略。</br>在销售、公关等需要沟通和应变能力的领域，ENTP 凭借出色的口才和创新思维，赢得客户和合作伙伴的认可。但他们可能过于追求新奇，做事缺乏耐心和坚持。',
    results:
      '1. 律师：在法庭上据理力争，维护客户权益。</br>2. 市场营销专家：策划创新营销方案。</br>3. 创业者：开拓新兴领域，寻找创业机会。</br>4. 咨询顾问：为企业提供专业咨询建议。</br>5. 发明家：创造发明新的产品或技术。',
  },
  INFJ: {
    name: 'INFJ',
    dignity: '提倡者型人格',
    account: '富有同情心，洞察力强，追求内在和谐',
    analyze:
      '内向（I）：习惯在内心世界深度探索自我，社交时更倾向于与少数人进行深入交流。在社交场合中，他们更愿意与志同道合的人进行一对一的深度对话。</br>直觉（N）：对人性和社会有着深刻的洞察，能够理解他人内心深处的情感和需求。像心理咨询师一样，能敏锐捕捉到来访者的潜在情绪。</br>情感（F）：决策基于个人价值观，富有同情心，关心他人的幸福，为弱势群体发声。在公益活动中，积极为贫困地区儿童争取教育资源。</br>判断（J）：目标明确，为实现理想默默努力，注重精神层面的追求，有坚定的信念。为了推动环保事业，会长期坚持宣传环保理念。</br>INFJ 在教育、公益等领域发挥着重要作用，如特蕾莎修女。但他们可能因过于理想化，在现实中容易遭受挫折，感到沮丧。',
    results:
      '1. 心理咨询师：倾听和帮助他人解决心理问题。</br>2. 作家：创作富有情感和深度的文学作品。</br>3. 教育工作者：引导学生成长，关注学生内心世界。</br>4. 人力资源专家：挖掘人才潜力，关心员工发展。</br>5. 艺术家：通过艺术作品表达内心感悟。',
  },
  INFP: {
    name: 'INFP',
    dignity: '调停型人格',
    account: '理想主义，善良温和，注重个人价值观',
    analyze:
      '内向（I）：沉浸在自己丰富的内心情感中，社交中可能较为安静，更关注内心感受。在社交聚会中，他们可能会安静地倾听他人分享，较少主动发言。</br>直觉（N）：对美好事物充满向往，拥有独特的价值观，能从抽象层面理解世界，追求理想中的生活。在文学创作中，常常描绘充满爱与美好的理想世界。</br>情感（F）：决策时情感占主导，追求和谐与公平，注重人际关系的融洽。在朋友间发生矛盾时，会努力调和双方关系，让大家重归于好。</br>知觉（P）：能够适应变化，注重个人成长，在理想与现实之间寻找平衡，不断调整自己的生活方式。当生活发生变故时，能积极调整心态，重新规划生活。</br>在艺术、文学等领域，INFP 凭借细腻的情感和丰富的想象力，创作出打动人心的作品，如作家三毛。但他们可能因过于敏感，容易受到外界负面评价的影响。',
    results:
      '1. 社会工作者：帮助弱势群体，改善社会问题。</br>2. 音乐家：创作触动人心的音乐作品。</br>3. 翻译：促进不同文化间的交流与理解。</br>4. 编辑：筛选和创作有价值的文字内容。</br>5. 非盈利组织工作人员：推动公益事业发展。',
  },
  ENFJ: {
    name: 'ENFJ',
    dignity: '主人公型人格',
    account: '热情开朗，善于激励他人，有强烈的责任感',
    analyze:
      '外向（E）：在社交中如鱼得水，善于鼓舞他人，能够轻松与他人建立良好的关系。在团队活动中，总能调动大家的积极性，让每个人都参与其中。</br>直觉（N）：能够理解他人的需求，洞察群体氛围，准确把握团队的动态，提前发现潜在问题。在团队合作中，能提前察觉成员之间的矛盾隐患，及时化解。</br>情感（F）：决策以他人感受为重，富有感染力，关心团队成员的情感需求。在团队遇到困难时，会给予鼓励和支持，让大家重拾信心。</br>判断（J）：积极组织活动，引领团队达成目标，是团队中的核心人物，具有强烈的责任感。在班级活动组织中，会精心策划每一个环节，确保活动圆满成功。</br>在教育、管理等领域，ENFJ 凭借强大的人格魅力和领导能力，激励他人成长，如马云。但他们可能因过度关注他人需求，忽略自身的发展。',
    results:
      '1. 教师：传授知识，培养学生品德和能力。</br>2. 销售经理：带领团队完成销售目标。</br>3. 培训师：提升他人知识和技能水平。</br>4. 公关专家：维护企业形象和公共关系。</br>5. 社区领袖：组织社区活动，解决社区问题。',
  },
  ENFP: {
    name: 'ENFP',
    dignity: '竞选者型人格',
    account: '充满活力，乐观积极，喜欢与人交往',
    analyze:
      '外向（E）：热情开朗，喜欢结交朋友，在社交场合中充满活力，善于与人交往。在新环境中，能迅速与周围人打成一片，结交新朋友。</br>直觉（N）：想象力丰富，充满新奇点子，对新事物充满好奇心，思维活跃。在头脑风暴中，总能提出令人眼前一亮的创意想法。</br>情感（F）：富有同理心，善解人意，关心他人的感受。当朋友遇到困难时，能感同身受，给予温暖的安慰和帮助。</br>知觉（P）：生活随性自由，追求新鲜体验，不断探索新事物，享受变化带来的乐趣。经常尝试新的美食、参加新的兴趣班，体验不同的生活方式。</br>在娱乐、传媒等领域，ENFP 凭借热情和创造力，吸引他人的关注，如脱口秀演员。但他们可能因过于追求自由，缺乏自律，难以完成长期目标。',
    results:
      '1. 演员：能够通过深入人心的表演展现角色魅力。</br>2. 广告创意人员：构思新颖的广告方案。</br>3. 记者：挖掘新闻事件，报道社会万象。</br>4. 活动策划师：策划精彩活动，吸引大众参与。</br>5. 旅游顾问：为游客规划独特旅行路线。',
  },
  ISTJ: {
    name: 'ISTJ',
    dignity: '物流师型人格',
    account: '严谨认真，注重细节，有强烈的责任感',
    analyze:
      '内向（I）：专注于细节，喜欢默默完成任务，不喜欢过多的社交打扰，更享受独自工作的时光。在学习工作中，他们会安静地完成自己手头的任务，不参与同学间的闲聊。</br>感觉（S）：注重实际事实，关注当下的具体情况，以现实为依据做出判断。在学习工作中，会严格按照实际和固定步骤操作，确保学习任务的准确性。</br>思考（T）：决策基于逻辑规则，严谨可靠，遵循既定的原则和标准。在处理学校事务时，严格遵守学校制度，不做违规操作。</br>判断（J）：遵循传统，有条理地安排生活与工作，是可靠的执行者，注重秩序和效率。每天的工作和生活都有明确的计划，按照计划有条不紊地进行。</br>在会计、档案管理等需要严谨和细致的工作中，ISTJ 凭借对规则的遵守和认真负责的态度，确保工作的准确无误，像资深会计，精准处理每一笔账目。但他们可能因过于墨守成规，缺乏创新意识。',
    results:
      '1. 会计：处理财务账目，保证数据准确。</br>2. 档案管理员：整理和保管档案资料。</br>3. 行政助理：协助领导处理日常行政事务。</br>4. 质量控制员：把控产品或服务质量。</br>5. 审计员：审查财务和业务流程。',
  },
  ISFJ: {
    name: 'ISFJ',
    dignity: '守卫者型人格',
    account: '忠诚可靠，乐于助人，注重和谐稳定',
    analyze:
      '内向（I）：内敛温和，默默奉献，不善于主动表达自己，更倾向于在幕后工作。在家庭聚会中，他们会默默准备饭菜、收拾餐具，不抢风头。</br>感觉（S）：关注具体细节和他人的需求，能够敏锐地察觉周围环境的变化，关心家人和朋友的生活点滴。能记住家人朋友的生日、喜好等细节，在特殊时刻送上贴心的礼物。</br>情感（F）：决策基于对他人的关怀，忠诚可靠，以维护人际关系为出发点。在朋友需要帮助时，毫不犹豫地伸出援手，提供物质或精神上的支持。</br>判断（J）：遵守规则，认真履行职责，在幕后维护秩序，确保一切按部就班地进行。在公司中，默默做好后勤保障工作，保证公司的正常运转。</br>在护理、服务等领域，ISFJ 凭借对他人的关怀和责任感，为他人提供温暖和支持，如护士，悉心照顾每一位患者。但他们可能因过度照顾他人，忽略自身需求。',
    results:
      '1. 护士：照顾病人，提供医疗护理服务。</br>2. 图书管理员：管理图书借阅和资料整理。</br>3. 客服代表：解答客户疑问，处理投诉。</br>4. 办公室行政人员：维持办公室日常运转。</br>5. 后勤人员：保障物资供应和后勤支持。',
  },
  ESTJ: {
    name: 'ESTJ',
    dignity: '总经理型人格',
    account: '果断务实，注重实际，有较强的组织能力',
    analyze:
      '外向（E）：在校园活动或者小组讨论里，ESTJ 类型的同学总是充满自信，能够轻松掌控场面，积极主动地和大家交流。比如在小组讨论时，他们会自信满满地说出自己的想法，还能巧妙引导讨论朝着目标前进。</br>感觉（S）：这类同学更关注当下实际情况，看重实实在在的成果，做决定都以事实为依据。就像参与社团活动策划时，他们会根据以往活动的实际反馈和现实条件，调整活动方案，确保活动能满足同学们的需求。</br>思考（T）：做决策的时候，ESTJ 类型的同学非常理性，分析问题头头是道，果断又高效，一心追求事情能快速出成果。假如参加学科竞赛，面对竞赛中的难题，他们能迅速分析利弊，做出合理的应对策略。</br>判断（J）：他们喜欢制定规则，对自己和身边的人要求都比较严格，追求有条不紊的秩序和高效。在班级里，可能会主动提出制定一些班级规则，督促同学们遵守，以此提升班级的整体学习氛围和效率在企业管理、政府部门等需要领导和决策的岗位上，ESTJ 凭借果断的决策和高效的管理能力，推动组织的发展，如企业高管，带领团队实现业绩增长。但他们可能因过于严格，让下属感到压力过大。',
    results:
      '1. 企业经理：管理企业日常运营。</br>2. 警察：维护社会治安，执行法律规范。</br>3. 银行柜员：办理金融业务，为客户进行服务。</br>4. 生产主管：管理生产流程和人员。</br>5. 学校管理员：管理学校行政事务。',
  },
  ESFJ: {
    name: 'ESFJ',
    dignity: '执政官型人格',
    account: '热情友善，善于社交，关心他人感受',
    analyze:
      '外向（E）：善于社交，乐于助人，在社交场合中积极活跃，喜欢与人互动。经常组织社交活动，如朋友聚会、社区活动等，增进人与人之间的感情。</br>感觉（S）：关注身边人的需求，注重细节，能够敏锐地察觉他人的情绪变化。在朋友心情不好时，能及时发现并给予关心和安慰。</br>情感（F）：决策基于维护人际关系，热情友善，以和谐的人际关系为目标。在朋友间协调矛盾，倾听双方意见，努力化解矛盾，维护友谊。</br>判断（J）：积极组织社交活动，维护社会和谐，是社交场合的活跃分子，注重传统和规范。遵循社会习俗和礼仪，在社交场合中表现得得体大方。</br>在公关、人力资源等领域，ESFJ 凭借良好的人际关系处理能力和组织能力，促进团队和组织的和谐发展，如人力资源经理，善于协调员工关系。但他们可能因过于在意他人看法，而失去自我判断。',
    results:
      '1. 办公室经理：协调办公室工作，管理团队。</br>2. 婚礼策划师：策划浪漫婚礼，满足新人需求。</br>3. 人力资源专员：招聘、培训和管理员工。</br>4. 餐厅经理：管理餐厅运营，提升服务质量。</br>5. 导游：引导游客参观景点，讲解文化知识。',
  },
  ISTP: {
    name: 'ISTP',
    dignity: '鉴赏家型人格',
    account: '冷静灵活，擅长动手操作，适应能力强',
    analyze:
      '内向（I）：冷静观察，默默积累经验，不喜欢过多的社交活动，更享受独自探索的过程。独自学习各类技术，通过反复实践掌握维修技巧。</br>感觉（S）：对实际操作有天赋，擅长动手，注重实际的体验和感受。在手工制作中，能凭借双手创造出精美的作品，感受制作过程的乐趣。</br>思考（T）：决策基于事实分析，灵活应变，能够根据实际情况迅速做出判断。在赛车比赛中，根据赛道情况和对手表现，灵活调整赛车策略。</br>知觉（P）：喜欢冒险，在实践中探索新技能，享受自由的生活方式，不喜欢被束缚。经常参加极限运动，如攀岩、跳伞等，挑战自我。</br>在机械、体育等需要实际操作和应变能力的领域，ISTP 凭借对技能的热爱和灵活的应变能力，取得优异的成绩，如赛车手，在赛道上展现速度与激情。但他们可能因过于冒险，忽视潜在风险。</br >',
    results:
      '1. 机械工程师：设计和制造机械设备。</br>2. 电工：负责电气设备安装和维修。</br>3. 消防员：应对火灾和救援任务。</br>4. 赛车手：参加赛车比赛，挑战速度极限。</br>5. 户外运动教练：指导户外运动，保障参与者的安全。',
  },
  ISFP: {
    name: 'ISFP',
    dignity: '探险家型人格',
    account: '热爱自由，富有艺术气质，关注当下体验',
    analyze:
      '内向（I）：安静内敛，专注于自身感受，在社交中较为低调，更关注内心世界。通过绘画来表达自己内心的情感，将情感融入画作中。</br>感觉（S）：对美和艺术有敏锐的感知，富有创造力，善于从生活中发现美好。在摄影中，能捕捉到生活中那些容易被忽视的美丽瞬间，创作出独特的摄影作品。</br>情感（F）：决策基于个人喜好，追求自由表达，以情感为驱动进行创作和行动。选择自己喜欢的艺术风格进行创作，不被传统束缚。</br>知觉（P）：喜欢体验新鲜事物，在生活中寻找灵感，享受自由随性的生活。经常去不同的地方旅行，感受不同的文化和风景，为创作寻找灵感。</br>在艺术、设计等领域，ISFP 凭借对美的独特理解和创造力，创作出令人赞叹的作品，如画家梵高，用独特的笔触和色彩表达内心的情感。但他们可能因过于追求个人喜好，缺乏商业意识。',
    results:
      '1. 平面设计师：设计视觉传达作品。</br>2. 摄影师：捕捉美好瞬间，记录生活。</br>3. 美容师：提升他人外在形象和美感。</br>4. 厨师：烹饪美食，创造味觉享受。</br>5. 手工艺人：制作精美手工艺品。',
  },
  ESTP: {
    name: 'ESTP',
    dignity: '企业家型人格',
    account: '外向开朗，喜欢社交，充满活力和冒险精神',
    analyze:
      '外向（E）：对于学生而言，他们充满活力，善于社交，在社交场合中总是积极主动，乐于与人交往。在参与校园活动时，他们积极结交新朋友，拓展人际网络。</br>感觉（S）：学生对现实变化有着敏锐的反应，能够迅速抓住机遇，以实际行动来应对各种挑战。当校园内出现新的机会或项目时，他们能够迅速行动，争取到宝贵的参与机会。</br>思考（T）：在决策时，学生会基于实际情况进行考量，果断采取行动，并十分注重实际效果和取得的成果。在参与学术竞赛或创业项目时，他们能够迅速做出决策并付诸实践，通过不断的尝试和调整，来实现自己的学术或商业目标。</br>知觉（P）：学生群体中有许多人喜欢冒险尝试，追求刺激和新鲜的体验，他们在实践中勇于创新，敢于突破传统。在参与科研项目或创新活动时，他们敢于尝试新的方法或模式，挑战学术或行业的常规，为学术进步或行业发展贡献力量。</br>在商业、创业等领域，ESTP 凭借敏锐的市场洞察力和勇于冒险的精神，取得商业成功，如企业家马斯克，不断在电动汽车、太空探索等领域创新。但他们可能因过于冒险，导致投资失败。',
    results:
      '1. 销售代表：开拓市场，销售产品或服务。</br>2. 企业家：创办和经营企业。</br>3. 体育教练：训练运动员，提升竞技水平。</br>4. 娱乐节目主持人：主持节目，活跃现场气氛。</br>5. 股票经纪人：从事股票交易和投资咨询。',
  },
  ESFP: {
    name: 'ESFP',
    dignity: '表演者型人格',
    account: '热情奔放，喜欢成为焦点，善于表达自己',
    analyze:
      '外向（E）：热情开朗，喜欢成为焦点，在社交中充满自信，善于展示自己。在舞台上尽情表演，用精彩的表演吸引观众的目光。</br>感觉（S）：对周围环境充满好奇，善于感知，能够敏锐地捕捉到周围的变化。在表演中，根据观众的反应调整表演节奏和内容，与观众形成良好的互动。</br>情感（F）：决策基于当下感受，享受生活，以快乐和满足为追求。选择自己喜欢的表演项目，享受表演过程中的快乐。</br>知觉（P）：随性自由，在社交中展现魅力，积极参与各种活动，享受生活的乐趣。经常参加各种社交聚会和演出，丰富自己的生活。</br>在演艺、娱乐等领域，ESFP 凭借热情和自信，吸引观众的目光，如演员，在荧幕上展现精彩的表演。但他们可能因过于追求当下快乐，缺乏长远规划。',
    results:
      '1. 演员：在影视、舞台上展现表演才华。</br>2. 舞蹈演员：用舞蹈表达情感和艺术。</br>3. 公关专员：维护企业形象，开展公关活动。</br>4. 市场营销专员：推广产品，吸引消费者。</br>5. 主持人：主持各类活动，掌控现场节奏。',
  },
}

export default mbtiData
